import { render, staticRenderFns } from "./customer-wx.vue?vue&type=template&id=43960006&scoped=true&"
import script from "./customer-wx.vue?vue&type=script&lang=js&"
export * from "./customer-wx.vue?vue&type=script&lang=js&"
import style0 from "./customer-wx.vue?vue&type=style&index=0&id=43960006&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43960006",
  null
  
)

export default component.exports